"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseImpl_1 = require("./parseImpl");
const validImpl_1 = require("./validImpl");
/**
 * Test if the phone number follows the correct digit rules to be a valid number in the
 * North American Numbering Plan area, which includes the US, Canada, and parts of the
 * Caribbean.
 * @param phoneNumber the phone number to test; formatting does not matter
 * @returns true if the phone number is potentially valid; false if it is not
 */
function valid(phoneNumber) {
    const parts = parseImpl_1.parseImpl(phoneNumber);
    return validImpl_1.validImpl(parts);
}
exports.valid = valid;
